import React, {useEffect, useState, useRef} from "react";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL, BACKEND_URL} from "../constants.js";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {Link} from "react-router-dom";

export function PatientActivityLog(props) {
    const sampleIdInput = useRef();
    const remarks = useRef();

    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const generateReportHandler = (e) => {
        e.preventDefault();
        if (!sampleIdInput.current.value) {
            alert('Please Enter a valid Sample ID');
            return false;
        }
        var queryString = '?sample_id=' + encodeURIComponent(sampleIdInput.current.value) + '&remarks=' + encodeURIComponent(remarks.current.value);
        window.open(`${BACKEND_URL}patient-activity-log${queryString}`);
    }

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title="Patient Activity Log Report">
                            <CardHeaderToolbar>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody>

                            <div className="mt-5">
                                <Form onSubmit={generateReportHandler}>
                                    <Form.Row>
                                        <Col md={7}>
                                            <Form.Label>Sample ID</Form.Label>
                                            <Form.Control type={'text'} ref={sampleIdInput} placeholder="Please Enter Sample ID"/>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col md={7}>
                                            <Form.Label>Remarks</Form.Label>
                                            <Form.Control as={'textarea'} ref={remarks}
                                                          placeholder="Enter remarks to be printed on report (Optional)"/>
                                        </Col>
                                    </Form.Row>

                                    <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                        Populate Report
                                        <span
                                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                    </Button>
                                </Form>

                            </div>

                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
}